import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="py-24 text-center text-slate-500">…</div>;
  if (!user) return <Navigate to="/auth" replace state={{ from: location.pathname + location.search }} />;
  // A password reset by the team must be replaced before anything else.
  if (user.must_change_password && location.pathname !== "/change-password") return <Navigate to="/change-password" replace />;
  return children;
};
